import type { ReactElement } from 'react';

import { Facepile } from '@xing-com/facepile';
import { IconCircleTick, IconCircleTickFilled } from '@xing-com/icons';
import { scale110 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

import * as Styled from './card-benefits-list.styled';
import type {
  BenefitsHeadlineProps,
  CardBenefitsListProps,
} from './card-benefits-list.types';

export type { CardBenefitsListProps } from './card-benefits-list.types';

const BenefitsHeadline = ({
  benefitsTitle,
  socialProof,
}: BenefitsHeadlineProps): ReactElement =>
  socialProof ? (
    <Styled.HeadlineContainer>
      <Facepile actors={socialProof} size="small" variant="condensed" />
      <Headline as="h3" size="small" noMargin>
        {benefitsTitle}
      </Headline>
    </Styled.HeadlineContainer>
  ) : (
    <Headline as="h3" size="medium" noMargin>
      {benefitsTitle}
    </Headline>
  );

export const CardBenefitsList = ({
  benefitsTitle,
  benefits,
  promoted,
  socialProof,
}: CardBenefitsListProps): ReactElement => {
  const TickIcon = promoted ? IconCircleTickFilled : IconCircleTick;
  return (
    <Styled.BenefitsListWrapper>
      <BenefitsHeadline
        benefitsTitle={benefitsTitle}
        socialProof={socialProof}
      />
      <Styled.List>
        {benefits.map((benefit) => (
          <Styled.ListItem key={benefit}>
            <TickIcon height={scale110} width={scale110} />
            <Styled.BenefitCopy data-qa="card-benefit-copy" size="small">
              {benefit}
            </Styled.BenefitCopy>
          </Styled.ListItem>
        ))}
      </Styled.List>
    </Styled.BenefitsListWrapper>
  );
};
